























import Vue from 'vue';
import { Avatar } from '@descomplica/vue-components';
import UserProfileInfo from './UserProfileInfo.vue';
import UserEmailPill from './UserEmailPill.vue';

export default Vue.extend({
  components: {
    Avatar,
    UserProfileInfo,
    UserEmailPill,
  },
  props: {
    email: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    handleSignOut: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    hasValidProps(): boolean {
      return !!this.email && !!this.handleSignOut;
    },
  },
  methods: {
    toggleInfo() {
      this.isOpen = !this.isOpen;
    },
  },
});
